import cookieHelper from './cookie';
var _ = require('underscore');

export default {
  upload: function (path, params, file, fileFormFieldName) {
    var keyVals = {
      params: JSON.stringify(params),
    };

    keyVals[fileFormFieldName || 'file'] = file;

    return this.uploadForm(path, keyVals);
  },

  uploadForm: function (path, keyVals) {
    return new Promise(function (ful, rej) {
      var formData = new FormData();

      _.each(keyVals, function (val, key) {
        formData.append(key, val);
      });

      var xhr = new XMLHttpRequest();

      // NOTE: keeping this around in case we add progress indicators later..
      // eslint-disable-next-line no-unused-vars
      xhr.upload.onprogress = function (e) {
        //TODO: make this work...problem is right now it's indicating when it's uploaded to app.v4, not when it's streamed to AWS S3
        //TODO: Possibly could emit a realtime message on server with real progress, and receive progress updates via socket.io
      };

      xhr.open('post', path, true);
      const csrfToken = cookieHelper.getCookie('XSRF-TOKEN');
      xhr.setRequestHeader('X-XSRF-TOKEN', csrfToken);

      xhr.onerror = function (e) {
        return rej({ error: e, path, fields: keyVals });
      };

      xhr.onload = function () {
        if (xhr.status == 200) {
          ful(JSON.parse(xhr.responseText));
        } else {
          var rejectionMessage = xhr.status;
          try {
            if (xhr.responseText)
              rejectionMessage = JSON.parse(xhr.responseText);
          } catch (e) {} // eslint-disable-line no-empty
          rej({ error: rejectionMessage, path, fields: keyVals });
        }
      };

      xhr.send(formData);
    });
  },
};
